import * as React from 'react';

import { Outlet, ScrollRestoration } from 'react-router-dom';

import AppNavigationWrapper from 'src/features/navigation/AppNavigationWrapper';
import { FallbackBlock } from 'src/registry/components/blocks/FallbackBlock';
import { getTabScrollKey } from 'src/utils/scrollRestoration';

const App = () => {
    return (
        <AppNavigationWrapper>
            {/*
             * Emulates the browser's native behaviour across client-side navigations: a new
             * location starts at the top, going back or forward restores the offset that location
             * was left at. `getKey` additionally groups a screen's tabs under one key so that
             * switching tab keeps your place — see getTabScrollKey for why the tab links'
             * `preventScrollReset` cannot do that job here.
             */}
            <ScrollRestoration getKey={getTabScrollKey} />
            <React.Suspense fallback={<FallbackBlock />}>
                <Outlet />
            </React.Suspense>
        </AppNavigationWrapper>
    );
};

export default App;
